import { render, staticRenderFns } from "./OverviewSphere.vue?vue&type=template&id=8c8c6646&scoped=true&"
import script from "./OverviewSphere.vue?vue&type=script&lang=js&"
export * from "./OverviewSphere.vue?vue&type=script&lang=js&"
import style0 from "./OverviewSphere.vue?vue&type=style&index=0&id=8c8c6646&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8c6646",
  null
  
)

export default component.exports